import { render, staticRenderFns } from "./OrdersManage.vue?vue&type=template&id=f192f514&"
import script from "./OrdersManage.vue?vue&type=script&lang=js&"
export * from "./OrdersManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports